import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const loggedIn = useSelector(state => state.authentication.loggedIn);
  const loggingOut = useSelector(state => state.authentication.loggingOut);
  const user = useSelector(state => state.authentication.user);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        loggedIn && !loggingOut && user ? (
          <Layout>
            <Component />
          </Layout>
        ) : (
            <Redirect to={{ pathname: '/', state: { from: location } }} />
          )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.object,
};

export default PrivateRoute;
